import { __spreadArrays } from "tslib";
import * as React from 'react';
import { BreakpointContext } from '../contexts/BreakpointContext';
import { breakpoints } from '../theme';
export var useBreakpoint = function (value) {
    var normalizedValue = Array.isArray(value) ? value : [value];
    if (normalizedValue.length > breakpoints.length) {
        throw new Error("There should be no more than " + breakpoints.length + " value entries");
    }
    var currentBreakpoint = React.useContext(BreakpointContext).currentBreakpoint;
    var missingValues = Array(breakpoints.length - normalizedValue.length).fill(normalizedValue[normalizedValue.length - 1]);
    var newValues = __spreadArrays(normalizedValue, missingValues);
    return newValues[currentBreakpoint];
};
